const endpoint = "https://ro1b.cuba-lv.com"

const cpoint = "https://central-backend.cuba-lv.com"
const startpoint = `${cpoint}/`

const mediapoint = "https://s3-media.cuba-lv.com"
const gamePlace = { studio: "tbilisi", room: "ro1-room" } //bishkek, tbilisi
const name = "Super Roulette"
const type = "super-roulette"
const logo = "superlogo"

export { endpoint, mediapoint, startpoint, gamePlace, name,type, logo }
